import { useMutation } from 'react-query';

import { QueryParams, QueryResponse, setReportFavoriteStatus } from 'api/endPoints/SetReportFavoriteStatus';

export const useMutationSetReportFavoriteStatus = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>({
        mutationFn: (params) => setReportFavoriteStatus(params),
    });
};
